import { HttpEvent, HttpHandler, HttpHeaders, HttpRequest, JsonpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RxJsonpInterceptor extends JsonpInterceptor {
  override intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const modifiedReq =
      req.method === 'JSONP'
        ? req.clone({
          headers: new HttpHeaders(),
        })
        : req;
    return next.handle(modifiedReq);
  }
}

